import Model from './Model'
import User from './User'
import Team from "./Team";
import ServiceOffering from "./ServiceOffering";

const Roles = {
	Owner: 'Owner',
	Admin: 'Admin',
	SuperAdmin: 'Super Admin',
	BaseUser: 'Base User',
	TalentResource: 'Talent Resource',
};

export default class Client extends Model
{
	static Key = 'Client';

	static Roles = Roles;

	static normalize(props)
	{
		if (props.industry) {
		    props.industry_id = props.industry.id;
        }
        if (props.consultant) {
            props.consultant = User.make({...props.consultant})
        }

        if (props.assets) {
            if (props.assets?.length) {
                const imageContentTypes = ['Image', 'Video'];
                props.assets = TB.map(TB.filter([...props.assets], asset => !!asset), asset => {
                    let formattedAsset = TB.cloneDeep(asset);
                    if (!formattedAsset.name) {
                        formattedAsset.name = asset.caption || (asset.path?.includes('http') ? `${asset.content_type}` : asset.path);
                    }
                    if (!formattedAsset.status) {
                        formattedAsset.status = 'done';
                    }

                    if (!formattedAsset.url && !(formattedAsset.path instanceof File)) {
                        formattedAsset.url = asset.path;
                    }

                    return formattedAsset;
                });
            }
        }
        if (props.key_clients) {
            props.key_clients = TB.orderBy(props.key_clients, [client => !!client.display_index,'display_index'], ['desc', 'asc']);
            props.key_clients = TB.map(props.key_clients, client => {
                let formattedClient = TB.cloneDeep(client);
                if (formattedClient.assets?.length) {
                    const imageContentTypes = ['Image', 'Video'];
                    let assets = TB.map(TB.filter([...formattedClient.assets], asset => !!asset), asset => {
                        let formattedAsset = TB.cloneDeep(asset);
                        if (!formattedAsset.name) {
                            formattedAsset.name = asset.caption || (asset.path?.includes('http') ? `${asset.content_type} - ${client.headline}` : asset.path);
                        }
                        if (!formattedAsset.status) {
                            formattedAsset.status = 'done';
                        }

                        if (!formattedAsset.url && !(formattedAsset.path instanceof File)) {
                            formattedAsset.url = asset.path;
                        }

                        return formattedAsset;
                    })
                    formattedClient.assets = assets;

                    let [imgAssets, docAssets] = TB.partition(assets, asset => imageContentTypes.includes(asset.content_type))
                    formattedClient.imgAssets = TB.orderBy(imgAssets, ['display_index', 'desc'])
                    formattedClient.docAssets = TB.orderBy(docAssets, ['display_index', 'desc'])
                }
                return formattedClient;
            })
        }
        if (props.location) {
            props.location.is_default = true;
        }
        if (props.locations?.length) {
            if (!props.location) {
                props.location = TB.find(props.locations, ['is_default' , true])
            }
            props.locations = TB.filter(props.locations, location => !location?.is_default)
        }

        if (props.service_offerings?.length) {
            props.service_offerings = ServiceOffering.makeMany(props.service_offerings)
        }

        if (props.targets_clients_enterprise ||
            props.targets_clients_mid ||
            props.targets_clients_small ||
            props.targets_clients_startup) {
            props.has_set_target_client_size = true;
        }else props.has_set_target_client_size = false;

        if (!props.regions) {
            props.regions = [{
                id: 1,
                name: 'US',
                countries: ['US'],
                display_index: 0,
            }]
        }
		return props;
	}

    defaultPercentMarkup() {
        let markup = TB.defaultClientPercentMarkup();

        if (this.time_materials_hourly_percent_markup) {
            markup = this.time_materials_hourly_percent_markup
        }
        markup = parseFloat(markup);
        if (markup > 1) {
            markup = markup / 100;
        }
        return markup
    }
	hasConsultant()
	{
		return TB.isDefined(this.consultant);
	}

	sizeName()
	{
		if (!this.size) {
			return;
		}

		return laravel.client_sizes[this.size];
	}

	isRegistered()
	{
		return this.is_registered;
	}

	hasProjects()
	{
		return this.total_projects > 0;
	}

	isAgency() {
	    return this.client_type === 'Agency'
    }

	isBrand() {
	    return this.client_type === 'Brand'
    }

    acceptsStandardSOW() {
        return this.accepts_standard_time_materials_contract
    }

	isSupplier() {
		return this.is_supplier;
	}

    requiresSSOProvider() {
        return !!this.sso_provider;
    }
	hasCompletedSupplierProfile() {
		if (!this.isSupplier()) {
			return true;
		}


		return !!this.name && !!this.website
            && !!this.size
            && (!!this.location || this.locations?.length > 0)
            && TB.stripHtml(this.about).length > 0
			&& this.approved_email_domains?.length > 0
        && this.has_set_target_client_size
	}

    // hasSetTargetClientSize() {
    //     return this.targets_clients_enterprise ||
    //     this.targets_clients_mid ||
    //     this.targets_clients_small ||
    //     this.targets_clients_startup
    // }

	static async fetchClient(clientId, requestOptions = {})
	{
		this.FetchRequest = TB.request(
			TB.api_endpoint(`/api/clients/${clientId}`)
		);

		let response = await this.FetchRequest.get(requestOptions).catch(console.warn);

		// console.log('Team @ fetch -> response');
		// console.log(response);

		if (!response
			|| !response.success
			|| !response.success.data
			|| !response.success.data.client)
		{
			return;
		}

		let client = {
			...response.success.data.client,
			supplied_talent_users: User.makeMany(response.success.data.client.supplied_talent_users || []),
			supplied_teams: Team.makeMany(response.success.data.client.supplied_teams || [])
		}
		return Client.make(client)
	}
}